import { memo } from "react";

import RadioButton from "../RadioComponent";

import styles from "./styles.module.scss";

import parse from 'html-react-parser';

const QuestionCards = (props) => {
  const {
    questionsList,
    activeIndex,
    animate,
    handleQuestionAnswer,
    selectedAnswer,
  } = props;

  return (
    <>
      {questionsList?.slice(activeIndex, activeIndex + 1).map((question) => (
        <div
          key={question?.assQuestionId}
          className={`${styles["question-wrapper"]} ${
            animate ? styles["stack-animate"] : ""
          }`}
        >
          {/* <div className={styles["card-back"]}></div>
          <div className={styles["card-middle"]}></div> */}

          <div className={styles["question-card"]}>
            <div className={styles["question-header"]}>
              Question {activeIndex + 1}
            </div>

            <div className={styles["question-body"]}>
              <p className={styles["question-text"]}>
                {parse(question?.question || '')}
              </p>

              <div className={styles["options-grid"]}>
                {question?.answers?.map((option) => (
                  <RadioButton
                    key={option?.assAnswerId}
                    name={`question-${question?.assQuestionId}`}
                    label={option?.answer}
                    checked={selectedAnswer?.assessmentAnswerId === option?.assAnswerId}
                    onChange={() =>
                      handleQuestionAnswer(question , option)
                    }
                    className={styles['options']}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default memo(QuestionCards);
